<template>
  <div class="user_container">
    <div class="detail_title_info">
      <div class="job_info_container">
        <div class="job_info">{{ job.position_name }}</div>
        <div class="salary_info">
          <span v-if="job.pay_min">{{ job.pay_min }}-{{ job.pay_max }}万</span
          ><span v-else>面议</span>
        </div>
      </div>
      <div class="base_info">
        <div class="city">
          <i class="el-icon-location base_info_icon"></i>{{ job.work_addr }}
        </div>
        <div class="year">
          <i class="el-icon-s-cooperation base_info_icon"></i
          >{{ job.work_experience }}
        </div>
        <div class="education">
          <i class="el-icon-user-solid base_info_icon"></i>{{ job.education }}
        </div>
      </div>
    </div>
    <div class="detail_content_info">
      <div class="job_detail_info">
        <div class="content_title_info">
          <div class="title_icon"></div>
          <div class="title_text">岗位职责</div>
        </div>
        <div class="detail_text_info">
          <div class="break-line" v-html="job.position_statement"></div>
        </div>
      </div>
      <div class="job_detail_info">
        <div class="content_title_info">
          <div class="title_icon"></div>
          <div class="title_text">岗位要求</div>
        </div>
        <div class="detail_text_info">
          <div class="break-line" v-html="job.job_requirements"></div>
        </div>
      </div>
      <div class="job_detail_info">
        <div class="content_title_info">
          <div class="title_icon"></div>
          <div class="title_text">备注</div>
        </div>
        <div class="detail_text_info">
          <div>{{ job.remark ? job.remark : "暂无" }}</div>
        </div>
      </div>
    </div>
    <div class="menu"></div>
    <div class="detail_footer_info">
      <div class="footer_info">
        <div class="title_icon"></div>
        <div class="title_text">填写本人联系方式</div>
      </div>
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名" prop="name">
            <br />
            <el-input
              v-model="ruleForm.name"
              style="width: 320px"
              placeholder="请输入投递人的姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <br />
            <el-radio-group v-model="ruleForm.sex">
              <el-radio-button
                style="margin-right: 30px; border-radius: 4px"
                label="男"
                ><i class="el-icon-male"></i> 男</el-radio-button
              >
              <el-radio-button
                style="border-left: 1px solid #dcdfe6; border-radius: 4px"
                label="女"
                ><i class="el-icon-female"></i> 女</el-radio-button
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="手机号码" prop="tel">
            <br />
            <el-input
              v-model="ruleForm.tel"
              style="width: 320px"
              placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <br />
            <el-input
              v-model="ruleForm.email"
              style="width: 320px"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item label="推荐人姓名" prop="empName">
            <br />
            <el-input
              v-model="ruleForm.empName"
              style="width: 320px"
              placeholder="请输入推荐人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="与推荐人关系" prop="relation">
            <br />
            <el-input
              v-model="ruleForm.relation"
              style="width: 320px"
              placeholder="请输入与推荐人关系"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="menu"></div>
    <div class="detail_footer_info">
      <div class="footer_info">
        <div class="title_icon"></div>
        <div class="title_text">上传简历文件</div>
      </div>
      <el-upload
        class="upload-demo"
        :action="action"
        :on-remove="remove"
        :file-list="fileList"
        :on-change="changeFile"
      >
        <img src="@/assets/user/upload.png" alt="" />
        <div class="el-upload__text">
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          支持最大20M内的多格式文件，以及多格式图片上传，如jpeg、jpg、png、html、pdf、doc、txt、xls、docx、xlsx、zip、rar、emt、ppt、omo等格式，iOS系统仅限11及以上版本
        </div>
      </el-upload>
    </div>
    <div class="menu"></div>
    <div class="primary">
      <el-button type="primary" @click="submitForm('ruleForm')"
        >立即创建</el-button
      >
    </div>
  </div>
</template>

<script>
import api from "@/apis/user";
export default {
  name: "HR",
  data() {
    return {
      id: "",
      job: {},
      token: "",
      ruleForm: {
        name: "",
        sex: "",
        email: "",
        tel: "",
        relation: "",
        empName: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入投递人的姓名", trigger: "blur" },
        ],
        tel: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (/^1[34578]\d{9}$/.test(value) == false) {
                callback(new Error("请输入正确的手机号"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        empName: [
          { required: true, message: "请输入推荐人姓名", trigger: "change" },
        ],
        relation: [
          {
            required: true,
            message: "请输入与被推荐人的关系",
            trigger: "blur",
          },
        ],
      },
      fileList: [],
      action: "",
      uuid: "",
    };
  },
  created() {},
  mounted() {
    this.id = this.$route.query.positionId;
    this.token = this.$route.query.empNo;
    this.getUUid();
    this.getList();
  },
  methods: {
    //获取岗位详情
    getList() {
      api.postInfo_next({ id: this.id, empNo: this.token }).then((data) => {
        this.job = data.data[0];
        if (this.job.pay_min) {
          let number = Number(this.job.pay_min);
          this.job.pay_min = number / 10000;
        }
        if (this.job.pay_max) {
          let number = Number(this.job.pay_max);
          this.job.pay_max = number / 10000;
        }
      });
    },
    //获取uuid
    getUUid() {
      api.uuid().then((data) => {
        this.uuid = data.data;
        this.action = `/hrApi/interview/sendResumeFileSelf?uuid=${this.uuid}&positionId=${this.$route.query.positionId}&empNo=${this.$route.query.empNo}`;
      });
    },
    //上传文件
    changeFile(file) {
      this.fileList.push({ name: file.name });
    },
    //删除文件
    remove(file) {
      api.deleteFileById({ uuid: this.uuid, fileName: file.name }).then(() => {
        const index = this.fileList.findIndex((item) => {
          return item.name === file.name;
        });
        this.fileList.splice(index, 1);
      });
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = {
            uuid: this.uuid,
            positionId: this.id,
            empNo: this.token,
            ...this.ruleForm,
          };
          if (this.fileList.length > 0) {
            api.sendResumeOther(obj).then((data) => {
              if (data.code == 200) {
                this.$message({
                  type: "success",
                  message: data.msg,
                  duration: 2000,
                });
              } else {
                this.$message({
                  type: "error",
                  message: data.data,
                  duration: 2000,
                });
              }
            });
          } else {
            this.$message({
              type: "warning", // success error warning
              message: "请投递简历",
              duration: 2000,
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  // width: 100%;
  min-height: 100vh;
  background: #fff !important;
  //   margin-top: 20px;
  .detail_title_info {
    background: #fff;
    padding: 25px;
    border-bottom: 1px solid rgba(241, 241, 241, 1);
    padding-bottom: 35px;
    .job_info_container {
      display: flex;
      justify-content: space-between;
      .job_info {
        font-size: 36px;
        font-weight: bold;
        color: #282b32;
      }
      .salary_info {
        font-size: 36px;
        font-weight: bold;
        color: #4ea27c;
      }
    }
    .base_info {
      overflow: hidden;
      margin-top: 20px;
      color: #969b9e;
      font-size: 28px;
      font-weight: bold;
      & > div {
        float: left;
        padding-right: 28px;
      }
      .base_info_icon {
        margin-right: 12px;
      }
    }
    .arrive_time_info {
      margin-top: 40px;
      color: #666666;
      font-size: 28px;
    }
  }
  .detail_content_info {
    padding: 25px;
    .content_title_info {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-top: 20px;
      .title_icon {
        width: 8px;
        height: 32px;
        margin-right: 20px;
        background: #4ea27c;
        border-radius: 4px;
      }
      .title_text {
        font-size: 32px;
        font-weight: bold;
        color: #282b32;
      }
    }
    .detail_text_info {
      text-overflow: ellipsis;
      margin-top: 20px;
      color: #666666;
      font-size: 30px;
      line-height: 56px;
      .break-line {
        white-space: pre-wrap;
      }
    }
  }
  .menu {
    width: 100%;
    height: 20px;
    background: rgba(247, 249, 250, 1);
  }
  .detail_footer_info {
    padding: 25px;
    margin-bottom: 20px;
    .footer_info {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;
      .title_icon {
        width: 8px;
        height: 32px;
        margin-right: 20px;
        background: #4ea27c;
        border-radius: 4px;
      }
      .title_text {
        font-size: 32px;
        font-weight: bold;
        color: #282b32;
      }
    }
  }
  .primary {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-button {
      width: 90%;
      height: 70%;
      background: rgba(78, 162, 124, 1);
      border: none;
    }
  }
}
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: rgba(78, 162, 124, 1) !important;
  border: rgba(78, 162, 124, 1) 1px solid;
}
.upload-demo {
  border: 1px solid #ccc;
  text-align: center;
  img {
    width: 70px;
    height: 70px;
    padding-top: 30px;
  }
  em {
    font-size: 30px;
  }
}
::v-deep .el-upload__tip {
  line-height: 40px;
}
.el-icon-upload {
  font-size: 50px;
  margin-top: 20px;
}
::v-deep .el-upload-list {
  padding-bottom: 20px !important;
}
</style>
